import { office365 } from 'calendar-link'
import moment from 'moment'

export const addEventToCalendarUrl = (event, vendor = 'outlook') => {
  const singleEvent = {
    title: event.title,
    start: moment(event.start, 'YYYY-MM-DD hh:mm:ss').toISOString(),
    end: event.allDay ? null : moment(event.end, 'YYYY-MM-DD hh:mm:ss').toISOString(),
    location: event.location,
    description: event.description,
    allDay: !!event.allDay,
  }

  if (vendor === 'outlook') {
    return office365(singleEvent)
  }

  return singleEvent
}
